var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLighting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "20px",
    viewBox: "0 0 10 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Electricity Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_landing-page-default",
    transform: "translate(-117.000000, -503.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accounts",
    transform: "translate(100.000000, 354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Tile",
    transform: "translate(0.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-container",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "fuel-icon-electric",
    points: "5 0 14.984375 0 11 7.96875 14.984375 7.96875 8 19.96875 8 10.96875 5 10.96875"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.3cf88b472d2ded89ff3837e128538774.svg";
export { ForwardRef as ReactComponent };